import angular from 'angular'

import { wrap, partial } from 'lodash-es'
import { delFromArray } from '../utils/arrayh'

import setCss from '../utils/set-css'
import envRaw from '../utils/env-raw'
import getSize from '../utils/get-size'
import StrictObj from '../utils/strict-obj'
import debugFields from '../utils/debug-fields'
import extractRawElm from '../utils/extract-raw-elm'
import viewportResize from '../utils/viewport-resize'

import { TRANSFORM, fmtTranslate } from '../utils/fmt-translate'

import Template from './ggs-notification.factory.ejs'

angular
  .module('ggs.notification')
  .factory('notification', NotificationProvider)

const DELAY = 3e3

const DEBUG = 'debug'
const INFO = 'info'
const WARN = 'warn'
const ERROR = 'error'

const CLASS_MAP = {
  [DEBUG]: 'ggs-ui-notification_debug',
  [INFO]: 'ggs-ui-notification_info',
  [WARN]: 'ggs-ui-notification_warn',
  [ERROR]: 'ggs-ui-notification_error'
}

const QS_BUTTON = '.ggs-ui-notification__button'

function NotificationProvider(
  $compile,
  $timeout,
  $rootScope,
  $rootElement,
  qh,
  domh,
  animate,
  debugObj) {

  const regList = []
  $rootScope.$on('$destroy', killAll)

  return debugObj('notification', StrictObj(debugFields({
    [DEBUG]: partial(renewOrShow, DEBUG),
    [INFO]:  partial(renewOrShow, INFO),
    [WARN]:  partial(renewOrShow, WARN),
    [ERROR]: partial(renewOrShow, ERROR)
  }, {
    _regList: regList,
    _show: show,
    _hide: hide,
    _kill: kill,
    _renew: renew,
    _killAll: killAll,
    _recalcAll: recalcAll
  })))

  function renewOrShow(type, message) {
    const duplicate = findByArgs(type, message)
    return duplicate
      ? renew(duplicate)
      : show(type, message)
  }

  function renew(duplicate) {
    $timeout.cancel(duplicate.timeoutId)
    duplicate.timeoutId = $timeout(duplicate.handler, DELAY)
    delFromArray(regList, duplicate)
    regList.push(duplicate)
    recalcAll()
  }

  function show(type, message) {
    const typeClass = CLASS_MAP[type]
    const scope = $rootScope.$new()
    const handler = () => hide(elm)

    scope.handler = handler
    scope.message = message
    scope.typeClass = typeClass

    const template = Template(StrictObj({ LE: envRaw.liveEditMode }))
    const elm = $compile(template)(scope)
    const timeoutId = $timeout(handler, DELAY)

    $rootElement.append(elm)

    const size = getSize(extractRawElm(elm))
    const reg = StrictObj({
      elm,
      type,
      scope,
      width: size.width,
      height: size.height,
      handler,
      message,
      timeoutId
    })

    regList.push(reg)
    recalcAll()
  }

  function hide(elm) {
    return qh.over(
      wrap(domh.find(elm, QS_BUTTON), animate.hide),
      wrap(elm, kill))
  }

  function kill(elm) {
    const reg = findByElm(elm)
    if (!reg) return

    delFromArray(regList, reg)
    $timeout.cancel(reg.timeoutId)

    reg.elm.remove()
    reg.scope.$destroy()

    recalcAll()
  }

  function findByElm(elm) {
    for (let index = regList.length - 1; index !== -1; index--) {
      const reg = regList[index]
      if (reg.elm === elm) {
        return reg
      }
    }
  }

  function findByArgs(type, message) {
    for (let index = regList.length - 1; index !== -1; index--) {
      const reg = regList[index]
      if ((reg.type === type) && (reg.message === message)) {
        return reg
      }
    }
  }

  function killAll() {
    for (let index = regList.length - 1; index !== -1; index--) {
      const reg = regList[index]
      kill(reg.elm)
    }
  }

  function recalcAll() {
    let top = 0
    let left = 0
    let maxWidth = 0
    const vHeight = viewportResize.getHeight()

    for (const reg of regList) {
      if ((top + reg.height) <= vHeight) {
        setCss(reg.elm, TRANSFORM, fmtTranslate(left, top))
      } else {
        top = 0
        left += maxWidth
        maxWidth = 0
        setCss(reg.elm, TRANSFORM, fmtTranslate(left, top))
      }

      top += reg.height
      if (reg.width > maxWidth) {
        maxWidth = reg.width
      }
    }
  }
}
